const styles = theme => ({
  ruleContainer: {
    fontSize: theme.constants.fontSizes.regular,
    marginBottom: 12,
    fontWeight: 'bold',
  },
});

export default styles;
